    <div class="he" [class.giris-tamam]="!girisAnimasyonu">

      <!-- ===== SCAN ANIMASYONU ===== -->
      @if (girisAnimasyonu) {
        <div class="scan-sahne">
          <div class="scan-line"></div>
          <div class="scan-grid"></div>
          <div class="scan-icerik">
            <div class="scan-halka">
              <div class="scan-halka-ic">
                <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
              </div>
            </div>
            <div class="scan-terminal">
              <span class="scan-satir s1">&#62; KART OKUNDU</span>
              <span class="scan-satir s2">&#62; KİMLİK DOĞRULANIYOR...</span>
              <span class="scan-satir s3">&#62; PERSONEL DOĞRULANDI ✓</span>
              <span class="scan-satir s4 scan-isim">&#62; {{ kisiIsim || 'KULLANICI' }}</span>
            </div>
          </div>
        </div>
      }

      <!-- ===== ANA İÇERİK (animasyon sonrası) ===== -->
      @if (!girisAnimasyonu) {
        <div class="ana-icerik">

          <!-- Mesai Sayacı -->
          <div class="mesai-kart">
            <div class="mesai-ust">
              <div class="mesai-led" [class.aktif]="true"></div>
              <span class="mesai-etiket">MESAİ AKTİF</span>
              <span class="mesai-giris-saat">{{ girisSaati || '--:--' }}</span>
            </div>
            <div class="mesai-kisi-isim">{{ kisiIsim }} {{ kisiSoyIsim }}</div>
            <div class="mesai-orta">
              <div class="mesai-halka-wrap">
                <svg class="mesai-halka-svg" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="42" fill="none" stroke="var(--hmi-panel-border, rgba(0,255,136,0.08))" stroke-width="4"/>
                  <circle cx="50" cy="50" r="42" fill="none" stroke="url(#mesaiGrad)" stroke-width="4"
                    stroke-linecap="round" stroke-dasharray="263.9"
                    [attr.stroke-dashoffset]="263.9 - (263.9 * mesaiYuzde / 100)"
                    transform="rotate(-90 50 50)" class="mesai-halka-fill"/>
                  <defs>
                    <linearGradient id="mesaiGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stop-color="#00ff88"/>
                      <stop offset="100%" stop-color="#00ccff"/>
                    </linearGradient>
                  </defs>
                </svg>
                <div class="mesai-halka-ic">
                  <div class="mesai-sure-roller">
                    @for (h of mesaiSureHaneler; track $index) {
                      @if (h === ':') {
                        <span class="mesai-roller-ayirici">:</span>
                      } @else {
                        <span class="mesai-roller-hane">
                          <span class="mesai-roller-ic" [style.transform]="'translateY(-' + (+h * 1.25) + 'em)'">
                            <span class="mesai-roller-rakam">0</span>
                            <span class="mesai-roller-rakam">1</span>
                            <span class="mesai-roller-rakam">2</span>
                            <span class="mesai-roller-rakam">3</span>
                            <span class="mesai-roller-rakam">4</span>
                            <span class="mesai-roller-rakam">5</span>
                            <span class="mesai-roller-rakam">6</span>
                            <span class="mesai-roller-rakam">7</span>
                            <span class="mesai-roller-rakam">8</span>
                            <span class="mesai-roller-rakam">9</span>
                          </span>
                        </span>
                      }
                    }
                  </div>
                  <span class="mesai-yuzde">%{{ mesaiYuzde }}</span>
                </div>
              </div>
            </div>
            <div class="mesai-durum-bar">
              <div class="mesai-durum-item">
                <span class="md-led yesil"></span>
                <span class="md-yazi">Vardiya</span>
                <span class="md-deger">08:00 - 17:00</span>
              </div>
              <div class="mesai-durum-item">
                <span class="md-led" [class.yesil]="!moladaMi" [class.sari]="moladaMi"></span>
                <span class="md-yazi">Durum</span>
                <span class="md-deger">{{ moladaMi ? 'MOLADA' : 'AKTİF' }}</span>
              </div>
            </div>
          </div>

          <!-- Bildirim Terminali -->
          <div class="bildirim-terminal">
            <div class="bt-baslik">
              <span class="bt-led"></span>
              <span class="bt-yazi">SİSTEM BİLDİRİMLERİ</span>
            </div>
            <div class="bt-satirlar">
              @for (b of bildirimler; track b.id) {
                <div class="bt-satir" [class.yeni]="b.yeni">
                  <span class="bt-zaman">{{ b.saat }}</span>
                  <span class="bt-mesaj">{{ b.mesaj }}</span>
                </div>
              }
              <span class="bt-cursor">_</span>
            </div>
          </div>

          <!-- Aksiyon Butonları — Her biri canlı mini sahne -->
          <div class="aksiyon-grid">

            <!-- Puantaj: Dönen saat -->
            <button class="aksiyon-btn" (click)="tikla.emit('puantaj')" style="--neon:#00ff88">
              <div class="ab-sahne">
                <div class="ab-saat-kadran">
                  <svg viewBox="0 0 40 40" class="ab-saat-svg">
                    <circle cx="20" cy="20" r="16" fill="none" stroke-width="1.5"/>
                    <line x1="20" y1="20" x2="20" y2="9" stroke-width="1.5" stroke-linecap="round" class="ab-akrep"/>
                    <line x1="20" y1="20" x2="20" y2="7" stroke-width="1" stroke-linecap="round" class="ab-yelkovan"/>
                    <circle cx="20" cy="20" r="1.5"/>
                  </svg>
                </div>
              </div>
              <div class="ab-bilgi">
                <span class="ab-led"></span>
                <span class="ab-yazi">Puantaj</span>
              </div>
            </button>

            <!-- Mola: Buhar çıkan kahve -->
            <button class="aksiyon-btn" (click)="tikla.emit('mola')" style="--neon:#ffcc00">
              <div class="ab-sahne">
                <div class="ab-kahve">
                  <span class="ab-kahve-bardak">☕</span>
                  <div class="ab-buhar-wrap">
                    <span class="ab-buhar b1"></span>
                    <span class="ab-buhar b2"></span>
                    <span class="ab-buhar b3"></span>
                  </div>
                </div>
              </div>
              <div class="ab-bilgi">
                <span class="ab-led"></span>
                <span class="ab-yazi">Mola</span>
              </div>
            </button>

            <!-- Devamsızlık: Animasyonlu checklist -->
            <button class="aksiyon-btn" (click)="tikla.emit('devamsizlik')" style="--neon:#00ccff">
              <div class="ab-sahne">
                <div class="ab-checklist">
                  <div class="ab-check-satir cs1"><span class="ab-check-kutu dolu"></span><span class="ab-check-cizgi w80"></span></div>
                  <div class="ab-check-satir cs2"><span class="ab-check-kutu dolu"></span><span class="ab-check-cizgi w60"></span></div>
                  <div class="ab-check-satir cs3"><span class="ab-check-kutu bos"></span><span class="ab-check-cizgi w70"></span></div>
                </div>
              </div>
              <div class="ab-bilgi">
                <span class="ab-led"></span>
                <span class="ab-yazi">Devamsızlık</span>
              </div>
            </button>

            <!-- Mesajlar: Nabız atan bildirim -->
            <button class="aksiyon-btn" (click)="tikla.emit('mesaj')" style="--neon:#ff6b6b">
              <div class="ab-sahne">
                <div class="ab-mesaj-sahne">
                  <svg viewBox="0 0 40 40" width="28" height="28" class="ab-mesaj-ikon">
                    <rect x="6" y="8" width="28" height="20" rx="4" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.4"/>
                    <polyline points="6,10 20,20 34,10" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3"/>
                  </svg>
                  <span class="ab-mesaj-badge">3</span>
                  <span class="ab-mesaj-ping"></span>
                </div>
              </div>
              <div class="ab-bilgi">
                <span class="ab-led"></span>
                <span class="ab-yazi">Mesajlar</span>
              </div>
            </button>

          </div>

        </div>
      }
    </div>
